export default __webpack_public_path__ + "static/media/ImageSectionImageText.43d3d6ca.svg";